var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('small',{staticClass:"ta-auction-lot-count"},[_vm._v(" "+_vm._s(_vm.auction.number_of_lots || 0)+" "+_vm._s(_vm.auction.number_of_lots == 1 ? _vm.$t('lot') : _vm.$t('lots'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }